<template>
  <div id="footer" class="container-fluid">
    <div class="footer-content container">
      <div class="footer-info">
        <h3>Faithruit International Limited</h3>
        <p class="address">Flat 2304, 23/F, Ho King Commercial Centre, 2-16 Fa Yuen Street, Mong Kok, Hong Kong</p>
      </div>
      <div class="footer-bottom">
        <p class="copy">&copy; {{ new Date().getFullYear() }} Faithruit. All Rights Reserved.</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  background: #0f172a;
  color: #94a3b8;
  padding: 40px 0 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.footer-info h3 {
  color: #f8fafc;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  letter-spacing: 1px;
}

.footer-info .address {
  font-size: 13px;
  margin-bottom: 20px;
  max-width: 600px;
  line-height: 1.6;
}

.footer-bottom {
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding-top: 20px;
  margin-top: 20px;
}

.copy {
  font-size: 12px;
  margin: 0;
}

@media screen and (max-width: 768px) {
  #footer {
    padding: 30px 0 15px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue